module.exports = __webpack_public_path__ + "img/qrcode_1.da49103a.jpg";